'use strict';

angular.module('far.fos_user.uniqueUser', [])
.directive('uniqueUser', function($log, $http, $q) {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: function(scope, element, attr, ngController) {
			ngController.$asyncValidators.uniqueUser = function(modelValue, viewValue) {
				var value = modelValue || viewValue;

				return $http.get(Routing.generate('api_entities_find_user', {email: value})).
					then(function resolved() {
						return $q.reject('exists');
					}, function rejected() {
						return true;
					});
			}
		}
	};
});